.popup {
  height: 300px;
  max-width: 900px;
}
